import LazyLoading from './lazyLoading.vue'
export default LazyLoading